<template>
  <PayResult />
</template>

<script lang="ts">
import Vue from 'vue';
import { bridge } from '@/common';
import PayResult from './components/PayResult.vue';

export default Vue.extend({
  name: 'App',

  components: {
    PayResult,
  },
  created() {
    bridge.setLLButton(() => false);
    document.body.addEventListener('touchstart', () => {}, { passive: true });
  },
});
</script>

<style lang="less" scoped></style>
